// @ts-nocheck
import { ReactComponent as AliPay } from './alipay.svg'
import { ReactComponent as Amex } from './amex.svg'
import { ReactComponent as Diners } from './diners.svg'
import { ReactComponent as Discover } from './discover.svg'
import { ReactComponent as Jcb } from './jcb.svg'
import { ReactComponent as Mastercard } from './mastercard.svg'
import { ReactComponent as Visa } from './visa.svg'
import { ReactComponent as Hiper } from './hiper.svg'
import { ReactComponent as Paypal } from './paypal.svg'
import { ReactComponent as Union } from './unionpay.svg'
import { ReactComponent as Maestro } from './maestro.svg'
import { ReactComponent as Hipercard } from './hipercard.svg'
import { ReactComponent as Elo } from './elo.svg'
import { ReactComponent as Generic } from './generic.svg'


export const creditCards = {
  aliPay: AliPay,
  amex: Amex,
  diners: Diners,
  discover: Discover,
  jcb: Jcb,
  mastercard: Mastercard,
  visa: Visa,
  hiper: Hiper,
  paypal: Paypal,
  union: Union,
  maestro: Maestro,
  hipercard: Hipercard,
  elo: Elo,
  generic: Generic
}